import { render, staticRenderFns } from "./WisdomDataModal.vue?vue&type=template&id=5ae8d238&"
import script from "./WisdomDataModal.vue?vue&type=script&lang=js&"
export * from "./WisdomDataModal.vue?vue&type=script&lang=js&"
import style0 from "./WisdomDataModal.vue?vue&type=style&index=0&id=5ae8d238&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports